import { createStyles } from '@material-ui/core';

const styles = createStyles({
  subscriptionContainer: {
    fontSize: '0.857rem',
    padding: '0.357rem',
    minHeight: 90,
    gridRow: 3,
    gridColumn: 1
  }
});

export default styles;
